<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkbox-change="(rows) => (checkedRows = rows)"
      @edit="openEdit"
      @delete="deleteWorkshops"
    >
      <template #header>
        <PageHeader ref="header" @query="getData" @reset="resetPage">
          <b-button
            v-if="allow('A')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="openCreate"
          >
            {{ $l('btn_add_workshop') || '新增车间' }}
          </b-button>

          <el-badge
            v-if="allow('D')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-danger"
              :disabled="!checkedRowCount"
              @click="deleteWorkshops()"
            >
              {{ $l('btn_del_workshop') || '删除车间' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
        </PageHeader>
      </template>

      <template #pager>
        <pagination
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          @change="handlePaginationChange"
        />
      </template>
    </PageMain>

    <EditDialog
      :visible.sync="editVisible"
      :data="editingRow"
      @saved="onSaved"
    />
  </div>
</template>

<script>
import lodash from 'lodash'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import PageHeader from './header.vue'
import PageMain from './main.vue'
import EditDialog from '../edit-dialog'

export default {
  components: { PageHeader, PageMain, EditDialog },
  mixins: [BaseTable, EditLoading],
  data() {
    return {
      usePage: true,
      checkedRows: [],
      editVisible: false,
      editingRow: null,
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
    listInspectionWorkshopCode() {
      return lodash.map(this.checkedRows, 'inspectionWorkshopCode').filter(Boolean)
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .dfInspectionWorkshopListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    openCreate() {
      this.editingRow = null
      this.editVisible = true
    },
    openEdit(row) {
      if (row && `${row.workshopStatus || ''}` === 'N') {
        this.$message.warning(
          this.$l('tips_workshop_invalid_no_edit') || '无效车间不可编辑',
        )
        return
      }
      this.editingRow = row || null
      this.editVisible = true
    },
    async deleteWorkshops(row) {
      if (row?.inspectionWorkshopCode && `${row.workshopStatus || ''}` === 'N') {
        this.$message.warning(
          this.$l('tips_workshop_invalid_no_delete') || '无效车间不可删除',
        )
        return
      }

      const listInspectionWorkshopCode = row?.inspectionWorkshopCode
        ? [row.inspectionWorkshopCode]
        : this.listInspectionWorkshopCode

      if (!listInspectionWorkshopCode?.length) {
        this.$message.warning(
          this.$l('tips_pl_select_delete') || '请选择需要删除的车间',
        )
        return
      }

      const confirm = await this.$confirm(
        this.$l('INDEX.tips_confirm_delete') || '确认要删除选择的记录吗？',
        this.$l('INDEX.tips_title_confirm') || '确认信息',
        {
          type: 'warning',
          draggable: true,
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确认',
        },
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .dfInspectionWorkshopDelApi({ listInspectionWorkshopCode })
        .catch(() => null)
      this.loadingClose()

      if (!res) return

      const { status, msg } = res
      const error = status !== 200
      this.$message({
        showClose: true,
        message:
          msg ||
          (error
            ? this.$l('tips_delete_failed') || '删除失败'
            : this.$l('tips_delete_success') || '删除成功'),
        type: error ? 'error' : 'success',
      })
      if (error) return

      this.clearCheckboxRow()
      this.reload()
    },
    onSaved() {
      this.clearCheckboxRow()
      this.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>

